import { useEffect, useState } from "react";
import { useHttp } from "./useHttp";
import { useDispatch } from "react-redux";

export const useGetAndSet = (resource, params, action, dataFresh, nofetch) => {
  const dispatch = useDispatch();
  const [data, loading, error] = useHttp(
    resource,
    "get",
    params,
    dataFresh,
    nofetch
  );
  if (error) {
    throw Error("There was an error");
  }

  // Only dispatch when a real fetch produces new data - NOT on every render.
  // (Previously this dispatch sat in the render body, so any edit that
  // re-rendered the component re-dispatched the fetched data and wiped the edit.)
  // undefined until the first fetch result reaches the store - "loaded" waits for that,
  // so a screen never renders against an empty list (e.g. departments) for one frame
  const [synced, setSynced] = useState(undefined);
  useEffect(() => {
    if (!loading && data !== null) {
      dispatch(action(data));
    }
    if (!loading) setSynced(data);
  }, [data, loading, action, dispatch]);

  return !loading && synced !== undefined;
};
